import Mutations from './mutations.js'
import Actions from './actions.js'
import Getters from './getters.js'

export default {
    namespaced:true,
    state(){
        return {
            usersRank:[],
            connectionUsers:[]//현재 접속된 유저.
        }
    },
    mutations:Mutations,
    actions:Actions,
    getters:Getters
}
